<mat-accordion
  [multi]="true"
  [@.disabled]="true">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Oggetti artistici' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-cards-oa-manager
      [cardId]="cardId"
      [form]="form?.get('relazioniBeniOA')"
      [classNames]="classNames">
    </app-cards-oa-manager>
  </mat-expansion-panel>
  <mat-expansion-panel [title]="'Fotografie'">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Fotografie' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-cards-f-manager
      [cardId]="cardId"
      [form]="form?.get('relazioniBeniF')"
      [classNames]="classNames"></app-cards-f-manager>
  </mat-expansion-panel>
  <mat-expansion-panel [title]="'Disegni'">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Disegni' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-cards-d-manager
      [cardId]="cardId"
      [form]="form?.get('relazioniBeniD')"
      [classNames]="classNames"></app-cards-d-manager>
  </mat-expansion-panel>
  <mat-expansion-panel [title]="'Stampe'">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Stampe' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-cards-s-manager
      [cardId]="cardId"
      [form]="form?.get('relazioniBeniS')"
      [classNames]="classNames"></app-cards-s-manager>
  </mat-expansion-panel>
  <mat-expansion-panel [title]="'Matrici incise'">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'Matrici incise' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-cards-mi-manager
      [cardId]="cardId"
      [form]="form?.get('relazioniBeniMI')"
      [classNames]="classNames"></app-cards-mi-manager>
  </mat-expansion-panel>
</mat-accordion>
